
/*
 * Public API Surface of ngx-videogular
 */


 // Modules
export * from './lib/buffering/vg-buffering.module';
export * from './lib/controls/vg-controls.module';
export * from './lib/core/vg-core.module';
export * from './lib/ima-ads/ima-ads.module';
export * from './lib/overlay-play/vg-overlay-play.module';
export * from './lib/streaming/vg-streaming.module';


// Required for Ivy Build of Library

// export * from './lib/buffering/vg-buffering';
// export * from './lib/controls/vg-controls';
// export * from './lib/controls/vg-fullscreen/vg-fullscreen';
// export * from './lib/controls/vg-mute/vg-mute';
// export * from './lib/controls/vg-play-pause/vg-play-pause';
// export * from './lib/controls/vg-playback-button/vg-playback-button';
// export * from './lib/controls/vg-volume/vg-volume';
// export * from './lib/controls/vg-quality-selector/vg-quality-selector';
// export * from './lib/controls/vg-scrub-bar/vg-scrub-bar';
// export * from './lib/controls/vg-scrub-bar/vg-scrub-bar-buffering-time/vg-scrub-bar-buffering-time';
// export * from './lib/controls/vg-scrub-bar/vg-scrub-bar-cue-points/vg-scrub-bar-cue-points';
// export * from './lib/controls/vg-scrub-bar/vg-scrub-bar-current-time/vg-scrub-bar-current-time';
// export * from './lib/controls/vg-time-display/vg-time-display';
// export * from './lib/controls/vg-track-selector/vg-track-selector';
// export * from './lib/core/vg-player/vg-player';
// export * from './lib/core/vg-media/vg-media';
// export * from './lib/core/vg-cue-points/vg-cue-points';
// export * from './lib/ima-ads/vg-ima-ads';
// export * from './lib/overlay-play/vg-overlay-play';










